module.exports = __webpack_public_path__ + "img/dice-three.fd291d88.svg";